import authedTrackingClient from './client';
export const createTracker = authedTrackingClient.createTracker;